import {info} from "services-comun/modules/browser/log";

import { Auth } from "../../../services/auth";
import { IConfig } from "../../../config";
import { Ruta, IRuta } from "../../ruta";

export class RedaccionTags extends Ruta {
    /* STATIC */
    public static build(config: IConfig, id: number): RedaccionTags {

        return new this({
            id,
            ruta: `${config.router.basePath}/redaccion/tags/`,
        });
    }

    /* INSTANCE */
    public constructor(data: IRuta) {
        super(data);
    }

    public async check(path: string): Promise<void> {

        if (path!=this.data.ruta) {
            return Promise.reject("Redaccion/Noticias: Rechazada");
        }
    }

    public async load(auth: Auth, config: IConfig, state?: any): Promise<void> {

        info("Cargando NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../componentes/navbar`);
        await NavBar.load(auth, config, state);
        info("Cargando Redaccion/Tags");
        const {RedaccionTags} = await import(/* webpackChunkName: "redaccion-noticias" */ `../../../componentes/redaccion/tags/tags`);
        await RedaccionTags.load(auth, config, state);
    }

    public async unload(): Promise<void> {
        info("Descargando Redaccion/Tags");
        const {RedaccionTags} = await import(/* webpackChunkName: "redaccion-noticias" */ `../../../componentes/redaccion/tags/tags`);
        await RedaccionTags.unload();
    }

    public async updateEstado(state?: any): Promise<void> {
        info("Actualizando el estado de NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../componentes/navbar`);
        await NavBar.updateEstado(state);
        info("Actualizando el estado de Redaccion/Tags");
        const {RedaccionTags} = await import(/* webpackChunkName: "redaccion-noticias" */ `../../../componentes/redaccion/tags/tags`);
        await RedaccionTags.updateEstado(state);
    }
}
